import { render, staticRenderFns } from "./monthlySavings.vue?vue&type=template&id=53e5f7a6"
import script from "./monthlySavings.js?vue&type=script&lang=js&external"
export * from "./monthlySavings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports